<lib-page-container [title]="isAdding ? 'Add Staff Campaign' : 'Edit Staff Campaign'" [loading]="screen.isLoading()"
  [version]="appVersion.version" [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button [disabled]="screen.isLoading()"
      *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]" (click)="onSave()" icon="save" tooltip="Save">Save</lib-button>
  </div>
  <div lib-page-body>
    <div class="flex-row gap-16">
      <app-campaign-base-edit class="wid-490" #campaignBase [campaign]="campaign" [isStaffCampaign]="true"></app-campaign-base-edit>

      <mat-card appearance="outlined" class="mat-typography flex-1">
        <mat-card-content>
          <mat-tab-group class="tab-group">
            <mat-tab label="Strategy">
              @if (campaign) {
                <app-staff-campaign-strategy #campaignStrategy [advertiserId]="advertiserId" [strategy]="campaign.strategy"></app-staff-campaign-strategy>
              }
            </mat-tab>
            <mat-tab label="Locations">
              <app-campaign-location-filters #campaignLocationFilters [campaignId]="campaignId"></app-campaign-location-filters>
            </mat-tab>
            <mat-tab label="Json">
              <pre>{{ campaign | json }}</pre>
            </mat-tab>
            @if (campaignId) {
              <mat-tab label="Media">
                <app-campaign-media #campaignMedia [campaignId]="campaignId"></app-campaign-media>
              </mat-tab>
            }
          </mat-tab-group>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
</lib-page-container>